import { AuthServices } from '@/features/auth/services';
import { auth } from '@/features/auth/types';

import type { GuardianProfile } from './get-guardian';

/** Body for PATCH /api/v1/guardians/me (`GuardianProfileRequestDto`). */
export type GuardianProfileUpdate = auth.GuardianProfileUpdateRequest;

/** Partial update of the signed-in guardian, via PATCH `/api/v1/guardians/me`. */
export async function updateGuardianMe(data: GuardianProfileUpdate): Promise<GuardianProfile> {
  return await AuthServices.updateGuardianInfo(data);
}
